import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { Metafield, Product } from 'src/app/shop';

@Component({
    selector: 'app-product-swatch-list',
    templateUrl: './product-swatch-list.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ProductSwatchListComponent {
  @Input() products!: Product[];
  @Input() activeProduct!: Product;

  hoverLabel?: string;

  getMetafield(product: Product, field: 'kleur_filter' | 'kleur_label' | 'kleurcode'): Metafield | undefined | null {
    return product.metafields?.filter(m => m?.key === field)?.[0];
  }

  getMetaImage(product: Product, field: string) {
    const image = product.metafields?.filter(m => m?.key === field)?.[0];
    return image?.reference?.image?.url ? `url('${image?.reference?.image?.url}')` : '';
  }

  getLabel(product: Product) {
    const customLabel = product.metafields?.filter(m => m?.key === 'kleur_label')?.[0];
    const filterLabel = product.metafields?.filter(m => m?.key === 'kleur_filter')?.[0];

    return customLabel?.value || filterLabel?.value || '';
  }
}
